import React from 'react';
import { ShefRatingChip } from 'src/shared/design-system/DishFirstShefCard/ShefRatingChip';
import { BaseCard } from './BaseCard';
import { RESULT_IMAGE_DIMENSIONS } from './consts';
import { useDishCard } from './hooks';
import { LoadingDishImage, LoadingRating, LoadingSubTitle, LoadingTitleTall, ResultImage } from './styles';
import { DishCardProps } from './types';

export const DishCard: React.FC<DishCardProps> = (props) => {
  const { dishResult } = props;
  const cardProps = useDishCard(props);

  return (
    <BaseCard
      {...cardProps}
      image={
        <ResultImage
          src={dishResult.imageUrl ?? ''}
          alt={dishResult.name ?? ''}
          sourceWidth={RESULT_IMAGE_DIMENSIONS}
          sourceHeight={RESULT_IMAGE_DIMENSIONS}
        />
      }
      rating={<ShefRatingChip averageRating={dishResult.averageRating} count={dishResult.ratingCount} />}
    />
  );
};

export const LoadingDishCard = () => (
  <BaseCard
    image={<LoadingDishImage />}
    title={<LoadingTitleTall />}
    subtitle={<LoadingSubTitle />}
    rating={<LoadingRating />}
  />
);
